import {AbstractControl} from '@angular/forms';
import {Base, BaseDTO} from './base';
import { Tenants } from './tenants';

export type Role = "admin" | "manager" | "rider" | "customer";

export interface UserFilters {
  search?: string;
  roles?: Role[];
  active?: boolean;
  filter?: string;
}

export interface UserDTO extends BaseDTO {
  name: string;
  surname: string;
  email: string;
  phone: string;
  password: string;
  user_roles: Role[];
  active?: boolean;
  default_tenant_id: number;
  fidelity_card_points: number;
  notes: string;
  tenant: string;
  tenants: Tenants[];
}
export class User extends Base {
  name: string;
  surname: string;
  email: string;
  phone: string;
  password: string;
  role: Role;
  active?: boolean;
  defaultTenantId: number;
  fidelityCardPoints: number;
  notes: string;
  tenant: string;
  tenants: Tenants[];

  constructor(source: UserDTO) {
    super(source);
    if (source) {
      this.name = source.name;
      this.surname = source.surname;
      this.email = source.email;
      this.password = source.password;
    if (source.user_roles ) {
      this.role = source.user_roles[0];
    } else {
      this.role = undefined;
    }
      this.fidelityCardPoints = source.fidelity_card_points;
      this.notes = source.notes;
      this.tenant = source.tenant;
      this.tenants = source.tenants;
      this.defaultTenantId = source.default_tenant_id;
      this.active = source.active;
      this.phone = source.phone;
    }
  }

  toDTO(): UserDTO {
    let result: UserDTO = <UserDTO>super.toDTO();
    result.name = this.name;
    result.surname = this.surname;
    result.email = this.email;
    result.password = this.password;
    result.user_roles = [];
    if (this.role) {
      result.user_roles.push(this.role);
    }
    result.active = this.active;
    result.fidelity_card_points = this.fidelityCardPoints;
    result.notes = this.notes;
    result.tenant = this.tenant;
    result.tenants = this.tenants;
    result.default_tenant_id = this.defaultTenantId;
    result.phone = this.phone;

    return result;
  }

  static fromFormGroup(formGroup: AbstractControl, original?: User) {
    const formModel = formGroup.value;
    let user: User = new User(null);
    user.name = formModel.name;
    user.surname = formModel.surname;
    user.email = formModel.email;
    user.password = formModel.password;
    user.role = formModel.role;
    user.active = formModel.active;
    user.fidelityCardPoints = formModel.fidelityCardPoints;
    user.notes = formModel.notes;
    user.tenant = formModel.tenant;
    user.tenants = formModel.tenants;
    user.defaultTenantId = formModel.defaultTenantId;
    user.phone = formModel.phone;

    if (original) {
      user.id = original.id;
    }
    return user;
  }

  get admin(): boolean {
    return this.hasRole("admin");
  }

  hasRole(role: Role): boolean {
    return this.role && this.role === role;
  }

  get fullName(): string {
    return `${this.name} ${this.surname}`;
  }

}
